import axiosInstance from "./axiosInstance";

export const Signupapi = async (data) => {
  const API_URL = "/api/v1/signup";
  return await axiosInstance.post(API_URL, data);
};
export const fetchJobapi = async () => {
  const API_URL = `/api/v1/admin/get-job`;
  return await axiosInstance.get(API_URL);
};
export const CreateJobapi = async (data) => {
  const API_URL = "/api/v1/create-job";
  return await axiosInstance.post(API_URL, data);
};
export const Deletejobapi = async (Id) => {
  const API_URL = `/api/v1/delete-job/${Id}`;
  return await axiosInstance.delete(API_URL);
};
export const fetchJobDetailapi = async (Id) => {
  const API_URL = `/api/v1/admin/get-job/${Id}`;
  return await axiosInstance.get(API_URL);
};
export const UpdateJobapi = async (Id, data) => {
  const API_URL = `/api/v1/update-job/${Id}`;
  return await axiosInstance.put(API_URL, data);
};

export const UpdateNewsapi = async (Id, data) => {
  const API_URL = `/api/v1/update-news/${Id}`;
  return await axiosInstance.put(API_URL, data);
};
